import ScalarTooltip_vue_vue_type_script_setup_true_lang_default from "./ScalarTooltip.vue.script.js";
/* empty css                            */
//#region src/components/ScalarTooltip/ScalarTooltip.vue
var ScalarTooltip_default = ScalarTooltip_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarTooltip_default as default };

//# sourceMappingURL=ScalarTooltip.vue.js.map